import { createReducer, on } from '@ngrx/store';
import { modulesActions } from '../actions/modules.actions';
import { Module } from '../models';
import { PaginationParams } from '../types';

export interface ModulesState {
    loaded: boolean | null;
    loading: boolean | null;
    modules: Module[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: ModulesState = {
    loaded: null,
    loading: null,
    modules: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const modulesReducer = createReducer(
    initialState,
    on(
        modulesActions.getModules,
        (state, { value }): ModulesState => ({
            ...state,
            loading: true,
            page: value.page,
            limit: value.limit,
            lastParams: value,
        }),
    ),
    on(
        modulesActions.getModulesSuccess,
        (state, { payload, total }): ModulesState => ({
            ...state,
            loaded: true,
            loading: false,
            modules: payload,
            total,
        }),
    ),
    on(
        modulesActions.getModulesError,
        (state): ModulesState => ({
            ...state,
            loaded: false,
            loading: false,
        }),
    ),
    on(modulesActions.clear, (): ModulesState => ({ ...initialState })),
);
